export const picklistTemplateProductDefaultValues = {};
